// Отмена запросов фильтры +
// Квери + 
import customHeaders, { getSpace } from '../../common/headers';
import Cookies from 'universal-cookie'
import { useState, useEffect, useRef } from 'react';
import { DropDownSelector, ButtonBasic, CheckboxToggle } from '@lk-gtcom/ecomlab-components';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import useGeneralStore from '../../store/general';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { options_prop_mp } from '../../common/globalVariables';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import "./MaintainingMarginality.scss"
import { TextPage } from '../../components/TextPage/TextPage';
import { StepItem } from '../../components/StepItem/StepItem';
import { useResponseHandler } from '../../common/auth';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { RequestController } from '../../common/filtersFunc';
import { usePushNotifications } from '../../common/pushNotification';
import { MoonLoader } from 'react-spinners';
import { useSavedFilters } from '../../common/useSavedFilters';

const options_sales_plan = [
    { label: 'FBM', value: 'FBM' },
    { label: 'FBS', value: 'FBS' },
    { label: 'DBS', value: 'DBS' },
    { label: 'EXPRESS', value: 'EXPRESS' }
]

// Заголовки таблицы
const header_list = [
    "Название параметра",
    "Единица измерения",
    "Тип параметра",
    "Использовать в расчетах"
]

const MaintainingMarginality = ({ }) => {
    // Обработка ошибок
    const { addErrorPush } = usePushNotifications();
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
    const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'setting-cost-price');
    const requestControllerRef = useRef(new RequestController());
    const cookies = new Cookies()
    const token = cookies.get('auth')

    // Атрибуты
    const [isLoadAtrrs, setIsLoadAtrrs] = useState(false)
    const [attrs, setAttrs] = useState([])
    const [file, setFile] = useState('')

    // Фильтры
    const filterConfig = [
        { key: 'mp', type: 'single' },
        { key: 'api', type: 'single' },
        { key: 'sales_plan', type: 'single' }
    ];

    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);

    const [selectedMp, setSelectedMp] = useState(options_prop_mp[0]);
    const [selectedApi, setSelectedApi] = useState([]);
    const [selectedSalesPlan, setSelectedSalesPlan] = useState([]);

    const [totalApi, setTotalApi] = useState(0);
    const [apiData, setApiData] = useState([]);
    const [apiPage, setApiPage] = useState(1);
    const [apiQuery, setApiQuery] = useState('');

    // Инициализация фильтров из URL параметров при первом рендере
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

    useEffect(() => {
        if (!isReady) return;
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.mp) setSelectedMp(urlParams.mp)
                if (urlParams.api) setSelectedApi(urlParams.api)
                if (urlParams.sales_plan) setSelectedSalesPlan(urlParams.sales_plan)

                // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
                setIsFilterRequest(prev => !prev);
            }, 10);
        }
    }, [urlParams, isReady]);

    // Первая инициализация url
    useEffect(() => {
        if (!isReady) return;
        updateURL({
            mp: urlParams?.mp || selectedMp,
            api: urlParams?.api || selectedApi,
            sales_plan: urlParams?.sales_plan || selectedSalesPlan,
        })
    }, [isReady]);

    //Фильтры
    const apiFilter = () => {
        const controller = requestControllerRef.current.createController('api');

        fetchApiFilterVer3({
            controller,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalApi,
            page: apiPage,
            setApiData: setApiData,
            set: setApiData,
            searchParam: apiQuery,
            selectedApi,
            selectedShop: selectedMp,
            filter: 'api_id',
        })?.finally(() => {
            requestControllerRef.current.removeController('api');
        })
    };

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        apiFilter();
    }, [apiPage, apiQuery, isFilterRequest]);

    // Получение параметров
    const fetchGetParams = (abortController = new AbortController()) => {
        if (!selectedMp?.value || !selectedApi?.value || !selectedSalesPlan?.value) return
        setIsLoadAtrrs(true)

        const url = `https://apps1.ecomru.ru:4655/v1/margin-calculation/price-attrs`

        const body = JSON.stringify({
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value,
            selling_program: selectedSalesPlan?.value
        });

        fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    setAttrs([])
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then((json) => setAttrs(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setIsLoadAtrrs(false)
            })
    };

    useEffect(() => {
        const abortController = new AbortController()
        fetchGetParams(abortController)
        return () => abortController.abort()
    }, [selectedMp, selectedApi, selectedSalesPlan]);

    // Скачать шаблон цен
    const fetchGetTemplate = async () => {
        const url = `https://apps1.ecomru.ru:4655/v1/margin-calculation/prices-excel-template`;

        try {
            // 1. Получаем JSON с URL файла
            const response = await fetch(url, { method: 'GET', headers });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(JSON.stringify(errorData));
            }

            const json = await response.json();
            if (!json?.url) throw new Error("URL файла не найден в ответе");

            // 2. Создаём скрытую ссылку и скачиваем файл
            const link = document.createElement('a');
            link.href = json.url;
            link.download = 'template.xlsx'; // Имя файла
            link.style.display = 'none'; // Скрываем ссылку
            document.body.appendChild(link);
            link.click(); // Автоматический клик

            // 3. Очищаем ссылку через небольшой таймаут
            setTimeout(() => {
                document.body.removeChild(link);
            }, 100);
        } catch (err) {
            console.error('Ошибка:', err);
        }
    };

    const [isLoadingCost, setIsLoadingCost] = useState(false)

    // Скачать затраты
    const fetchGetCost = async () => {
        setIsLoadingCost(true)
        const url = `https://apps1.ecomru.ru:4655/v1/margin-calculation/mp-costs-excel-report`;

        const body = JSON.stringify({
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value,
            selling_program: selectedSalesPlan?.value
        });

        try {
            // Выполняем GET-запрос (или другой метод, если требуется)
            const response = await fetch(url, {
                method: 'POST', // или 'POST', если необходимо
                headers,
                body
            });

            // Проверяем, успешен ли ответ
            if (!response.ok) {
                throw new Error(`Ошибка HTTP: ${response.status}`);
            }

            // Извлекаем имя файла из заголовка Content-Disposition, если оно есть
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = 'calculated-price-report.xlsx'; // имя по умолчанию

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch) {
                    filename = decodeURIComponent(filenameMatch[1]);
                }
            }

            // Преобразуем ответ в Blob
            const blob = await response.blob();

            // Создаем временную ссылку для скачивания
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename; // Устанавливаем имя файла
            document.body.appendChild(link);
            link.click(); // Имитируем клик для скачивания

            // Убираем ссылку и освобождаем URL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            setIsLoadingCost(false)
        } catch (error) {
            setIsLoadingCost(false)
            console.error('Ошибка при скачивании файла:', error);
            // Можно добавить обработку ошибок, например, уведомление пользователя
        }

    };

    // Скачать excel с рассчетами
    const fetchGetExcelFile = async () => {
        const url = `https://apps1.ecomru.ru:4655/v1/margin-calculation/excel-report`;

        const body = JSON.stringify({
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value,
            selling_program: selectedSalesPlan?.value,
            file_url: file?.url,
            attrs: attrs
        })

        fetch(url, {
            method: 'POST',
            body,
            headers
        })
            .then((res) => {
                if (!res.ok) throw new Error('Export failed');

                const contentDisposition = res.headers.get('Content-disposition');
                let filename = 'table.xlsx'; // значение по умолчанию

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);

                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                        filename = filename.replace(/^"+|"+$/g, ''); // убираем кавычки, если есть
                    }
                }

                return res.blob().then(blob => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Export error:', err);
                    alert('Ошибка при выгрузке');
                }
            })
    };

    // Загрузить файл
    const fetchPostFile = (file) => {
        if (file) {
            const fd = new FormData();
            fd.append('file', file);
            const url = `https://file.ecomru.ru:4453/api/v1/file/upload`;

            // Создаем новый объект XMLHttpRequest
            const xhr = new XMLHttpRequest();

            // Устанавливаем метод и URL
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Cache-control', 'no-cache');
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            xhr.setRequestHeader('Space', selectedSpace?.value);

            // Обрабатываем успешную загрузку
            xhr.onload = () => {
                if (handleStatusCode(xhr.status)) {
                    return;
                }
                if (xhr.status === 200) {
                    const json = JSON.parse(xhr.responseText);
                    if (json) {
                        const current = {
                            new_filename: json?.name,
                            url: json?.url,
                            file_size_kb: json?.size,
                            created_at: json?.created_at,
                            extension: json?.extension,
                        }
                        setFile(current)
                    }
                } else {
                    console.error('Upload failed: ', xhr.statusText);
                }
            };

            // Обрабатываем ошибку
            xhr.onerror = () => {
                console.error('Error occurred during file upload');
            };

            // Отправляем данные
            xhr.send(fd);

        }
    };

    // Обработчик изменения чекбокса
    const handleCheckboxChange = (attributeName, newValue) => {
        const updatedAttrs = attrs.map(attr =>
            attr.attribute_name === attributeName
                ? { ...attr, in_use: newValue }
                : attr
        );
        setAttrs(updatedAttrs);
    };

    const handleFileChange = async (e) => {
        fetchPostFile(e.target.files[0])
    };

    return (
        <div className='maintaining-marginality'>
            <TitlePage
                title='Расчет маржинальности'
            />

            <FilterContainer
                loading={isSaved}
                saveFilters={saveFilters}
                clearSavedFilters={clearSavedFilters}
                hasSavedFilters={hasSavedFilters}
                onReset={(e) => {
                    setSelectedApi([]);
                    setSelectedMp([]);
                    setSelectedSalesPlan([])
                    updateURL({
                        mp: null,
                        api: null,
                        sales_plan: null
                    });
                    setIsFilterRequest(!isFilterRequest);
                    setAttrs([])
                }}
            >
                <DropDownSelector
                    state={selectedMp}
                    options_prop={options_prop_mp}
                    setState={(e) => setSelectedMp(e)}
                    total={options_prop_mp?.length}
                    placeholder="Площадка"
                    onBlur={() => {
                        apiFilter()
                        updateURL({ mp: selectedMp });
                    }}
                />

                <DropDownSelector
                    state={selectedApi}
                    options_prop={apiData}
                    total={totalApi}
                    setState={setSelectedApi}
                    placeholder="Магазин"
                    fetchCallback={setApiPage}
                    setInputChange={setApiQuery}
                    onBlur={(e) => {
                        updateURL({ api: selectedApi });
                    }}
                />

                <DropDownSelector
                    state={selectedSalesPlan}
                    options_prop={options_sales_plan}
                    setState={(e) => setSelectedSalesPlan(e)}
                    placeholder="Схема продаж"
                    onBlur={(e) => {
                        updateURL({ sales_plan: selectedSalesPlan });
                    }}
                />
            </FilterContainer>

            {(!selectedMp?.value || !selectedApi?.value || !selectedSalesPlan?.value) && <StepItem
                title='Заполните фильтры для получения атрибутов'
            />}

            {isLoadAtrrs ?
                <MoonLoader
                    size={40}
                    color="#7b7b7b"
                    speedMultiplier={0.5}
                />
                :
                (attrs.length > 0 ?
                    <div className={`maintaining-marginality__table`}>
                        <div className={`maintaining-marginality__table-headers`}>
                            {header_list?.map((point) => {
                                return <div
                                    className={`maintaining-marginality__table-headers-item`}
                                    key={point}
                                >
                                    <TextPage
                                        text={point}
                                        style={{
                                            fontWeight: 700
                                        }}
                                    />
                                </div>
                            })}
                        </div>

                        {
                            attrs?.map(({ attribute_group, attribute_name, name, unit, attr_type, in_use }, ind) => {
                                const array_item = [name, unit, attr_type, 'checkbox']
                                return <div
                                    className={`maintaining-marginality__table-row`}
                                    key={name}
                                >
                                    {array_item.map((item, ind) => {
                                        return <div key={item + ind} className={`maintaining-marginality__table-row-item`}>
                                            {ind == 3
                                                ?
                                                <CheckboxToggle
                                                    value={in_use}
                                                    onChange={(e) => handleCheckboxChange(attribute_name, e)}
                                                />
                                                :
                                                <TextPage
                                                    text={item || 'Не назначено'}
                                                    style={{
                                                        color: item ? '' : '#888888'
                                                    }}
                                                />}
                                        </div>
                                    })}
                                </div>
                            })}
                    </div>
                    :
                    <>
                        <TextPage
                            text='Нет доступных атрибутов'
                        />
                    </>
                )
            }



            <div className='maintaining-marginality__btn-group'>
                <ButtonBasic
                    whiteBlue
                    text='Шаблон загрузки Excel'
                    onClick={() => fetchGetTemplate()}
                />


                <div className='maintaining-marginality__btn-upload'>
                    <ButtonBasic
                        blue
                        text='Загрузить'
                    />

                    <input
                        type="file"
                        id="fileInput"
                        accept=".xls, .xlsx"
                        onChange={handleFileChange}
                    />
                </div>

                {file?.url &&
                    <a
                        key={file?.url}
                        className='maintaining-marginality__link'
                        href={file?.url}
                        download={file?.url}
                    >{file?.url}</a>
                }
            </div>

            <ButtonBasic
                whiteBlue
                width='340px'
                text='Выгрузить затраты на маркетплейсе по товарам'
                onClick={() => fetchGetCost()}
                loading={isLoadingCost}
                disabled={!selectedMp?.value || !selectedApi?.value || !selectedSalesPlan?.value}
            />

            <ButtonBasic
                green
                text='Скачать таблицу'
                disabled={!file?.url || !selectedMp?.value || !selectedApi?.value || !selectedSalesPlan?.value}
                onClick={() => fetchGetExcelFile()}
            />
        </div>
    )
}

export { MaintainingMarginality }